var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoVolna = function SvgLogoVolna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.071,
    fill: "#F4F6FB",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB008C",
    d: "M19.505 3.596a6.755 6.755 0 0 0-6.75 6.75v12.917s10.296-6.924 11.514-8.147a6.744 6.744 0 0 0-4.764-11.52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0000BE",
    d: "M26.25 28.79a6.75 6.75 0 1 1-13.499.01 6.75 6.75 0 0 1 13.499-.01"
  })));
};
export default SvgLogoVolna;